var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.userLogged)?_c('Topbar',{attrs:{"userName":_vm.userName,"companyName":_vm.companyName}}):_vm._e(),_c('v-content',{staticStyle:{"background-color":"rgb(244,244,244)","height":"100vh"},attrs:{"fluid":""}},[(_vm.userLogged)?_c('Titlebar'):_vm._e(),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }